/**
 * Collection card colour swatches — swap primary image on click © Pankaj Maurya
 * - Same-product colour options (data-swap-in-place): prevent navigation, swap image
 * - Title siblings (data-card-preview): preview image immediately, then navigate
 */
(function () {
  if (window.__cardColourImagesBound) return;
  window.__cardColourImagesBound = true;

  function findCard(node) {
    return node && node.closest ? node.closest('.card-wrapper--collection, .card-wrapper, article[data-product-id]') : null;
  }

  function setPrimaryImage(card, src, srcset, alt) {
    if (!card || !src) return;
    var img = card.querySelector('[data-card-primary-image]') || card.querySelector('.media > img');
    if (!img) return;
    img.src = src;
    if (srcset) img.setAttribute('srcset', srcset);
    if (alt) img.setAttribute('alt', alt);
  }

  function setCurrentDot(swatchesRoot, activeDot) {
    if (!swatchesRoot) return;
    swatchesRoot.querySelectorAll('.card-colour-swatches__dot.is-current').forEach(function (el) {
      el.classList.remove('is-current');
      el.removeAttribute('aria-current');
    });
    if (activeDot) {
      activeDot.classList.add('is-current');
      activeDot.setAttribute('aria-current', 'true');
    }
  }

  document.addEventListener(
    'click',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var dot = target.closest('.card-colour-swatches__dot[data-card-image]');
      if (!dot) return;

      var swatches = dot.closest('[data-card-colour-swatches]');
      var card = findCard(dot);
      var src = dot.getAttribute('data-card-image');
      var srcset = dot.getAttribute('data-card-image-srcset') || '';
      var alt = dot.getAttribute('data-card-image-alt') || '';
      var swapInPlace = swatches && swatches.getAttribute('data-swap-in-place') === 'true';
      var isPreview = dot.getAttribute('data-card-preview') === 'true';

      if (!src || !card) return;

      if (swapInPlace) {
        event.preventDefault();
        setPrimaryImage(card, src, srcset, alt);
        setCurrentDot(swatches, dot);
        return;
      }

      /* Sibling colours: instant preview then allow navigation */
      if (isPreview) {
        setPrimaryImage(card, src, srcset, alt);
        setCurrentDot(swatches, dot);
      }
    },
    true
  );

  /* Hover preview for sibling colour dots on desktop */
  document.addEventListener(
    'mouseover',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var dot = target.closest('.card-colour-swatches__dot[data-card-image][data-card-preview="true"]');
      if (!dot) return;
      var card = findCard(dot);
      if (!card) return;
      var img = card.querySelector('[data-card-primary-image]');
      if (!img) return;
      if (!img.dataset.originalSrc) {
        img.dataset.originalSrc = img.currentSrc || img.src;
        img.dataset.originalSrcset = img.getAttribute('srcset') || '';
        img.dataset.originalAlt = img.getAttribute('alt') || '';
      }
      setPrimaryImage(
        card,
        dot.getAttribute('data-card-image'),
        dot.getAttribute('data-card-image-srcset') || '',
        dot.getAttribute('data-card-image-alt') || ''
      );
    },
    true
  );

  document.addEventListener(
    'mouseout',
    function (event) {
      var target = event.target;
      if (!target || !target.closest) return;
      var swatches = target.closest('[data-card-colour-swatches]');
      if (!swatches || swatches.getAttribute('data-swap-in-place') === 'true') return;
      var related = event.relatedTarget;
      if (related && swatches.contains(related)) return;
      var card = findCard(swatches);
      if (!card) return;
      var img = card.querySelector('[data-card-primary-image]');
      if (!img || !img.dataset.originalSrc) return;
      img.src = img.dataset.originalSrc;
      if (img.dataset.originalSrcset) img.setAttribute('srcset', img.dataset.originalSrcset);
      if (img.dataset.originalAlt) img.setAttribute('alt', img.dataset.originalAlt);
    },
    true
  );
})();
